import UserData from './UserData';

export default UserData;
